<template>
  <transition name="fade" @before-enter="beforeEnter" @enter="enter">
    <div :class="[animatedNumberClass, customClass]">
      {{ formatNumber(animatedValue) }}{{ suffix }}
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      targetValue: {
        type: Number,
        required: true,
      },
      duration: {
        type: Number,
        default: 2000,
      },
      suffix: {
        type: String,
        default: '',
      },
      customClass: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        animatedValue: 0,
      };
    },
    computed: {
      animatedNumberClass() {
        // 添加你的动态类名逻辑
        return 'animated-number';
      },
    },
    methods: {
      beforeEnter(el) {
        el.style.opacity = '0'; // 初始透明度为 0
      },
      enter(el, done) {
        let startTime = null;

        const animate = (currentTime) => {
          if (!startTime) startTime = currentTime;

          const progress = (currentTime - startTime) / this.duration;
          if (progress < 1) {
            this.animatedValue = progress * this.targetValue;
            requestAnimationFrame(animate);
          } else {
            this.animatedValue = this.targetValue;
            el.style.opacity = '1'; // 最终透明度为 1
            done(); // 动画完成时调用 done 函数
          }
        };

        requestAnimationFrame(animate);
      },
      formatNumber(number) {
        // 添加逗号格式化数字
        return number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
    },
    beforeMount() {
      // 在组件挂载前手动触发一次动画
      this.enter(this.$el, () => {});
    },
    watch: {
      // 监听 animatedValue 变化，将其保存到本地存储中
      animatedValue(newValue) {
        localStorage.setItem('animatedValue', newValue.toString());
      },
    },
  };
</script>

<style scoped>
  .animated-number {
    /* 添加你需要的样式 */
    transition: opacity 1s;
    /* 使用 CSS 过渡 */
  }
</style>



// WEBPACK FOOTER //
// src/components/AnimatedNumber.vue